module.exports = __webpack_public_path__ + "media/hyper/images/small/small-4-0fdf575831b2c5fe81d982a2793adb46.jpg";